import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { Observable } from 'rxjs';
import { DataService } from '../../shared/services';
import { map } from 'rxjs/operators';

@Injectable()
export class CustomerSelectorFactoryPluginService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  updateCustomer(inspectionId: string, pluginId: string, customer: any): Observable<any> {
    if (this.isManager) {
      return this.dataService.getPlugin(inspectionId, pluginId).pipe(
        map((plugin) => {
          if (plugin) {
            plugin.config = customer;
            return { plugin };
          }
        })
      );
    }
    return this.getInspection(inspectionId).pipe(
      map((inspection) => {
        const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
        if (plugin) {
          inspection.insptectionInspectionCustomer = customer;

          if (!inspection.insptectionInspectionCustomer.id) {
            inspection.insptectionInspectionCustomer.id = this.guid();
          }
          inspection.customerName = customer.Name;
          plugin.config = customer;
          plugin.etag = new Date();
          this.updateInspection(inspection);
          return { customer: inspection.insptectionInspectionCustomer, plugin };
        }
        return null;
      })
    );
  }
}
